import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom"
import 'simplebar/dist/simplebar.min.css';
import { Layout } from "../Layout/Layout";



const AppRoute = ({
  component: Component,
  isAuthProtected,
  ...rest
}: any) => {
  const { token, me } = useSelector((store: any) => store.auth);
  
  return (
    <Route
      {...rest}
      render={props => {
        // If it's a protected route, check authentication
        if (isAuthProtected) {
          // If we have a token but no user data yet, show a loading state
          // This prevents the sidebar from trying to access null user properties
          if (token && me === null) {
            return (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading...</p>
                </div>
              </div>
            );
          }
          
          // If no token or no user data, redirect to login
          if (!token || !me) {
            return (
              <Redirect
                to={{ pathname: "/login", state: { from: props.location } }}
              />
            );
          }
          
          // User is authenticated, render the protected route with layout
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }

        // Public route, render without layout
        return <Component {...props} />;
      }}
    />
  );
};

export default AppRoute